import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiListAndData } from "../app/apiListAndData";
import { fetchApiData } from "../app/productService";

const getReplacementKeys = (params) => {
    const { property_id, as_of_date, date_from, date_until } = params;
    const replacements = {
        pid: property_id,
        asOfDate: as_of_date,
        fromDate: date_from,
        toDate: date_until
    };
    return replacements;
}
function getCurrentStateData(app_state) {
    let { property_id, primary_stay_range: { as_of_date, date_from, date_until } } = app_state;
    as_of_date = (as_of_date) ? as_of_date : app_state.as_of_date;
    return { property_id, as_of_date, date_from, date_until };
}

const addParametersValues = (url, replacements) => {
    url = url.replace(/{(.*?)}/g, (match, key) => {
        return replacements[key] || match;
    });
    return `${url}`;
    // return `${API_BASE_URL}${url}`;
}


export const callApiDirect_xx = async (app_state, apiName, payload, method = 'POST') => {
    let endpoint = apiListAndData[apiName]?.url;
    const { property_id, as_of_date, date_from, date_until } = getCurrentStateData(app_state);
    const replacements = getReplacementKeys(getCurrentStateData(app_state));
    endpoint = addParametersValues(endpoint, replacements);

    try {
        const result = await fetchApiData(endpoint, payload, method);
        return result; // you can return result.data or whole result depending on use-case
    } catch (error) {
        console.error('API call failed:', error);
        return { isSuccess: false, error };
    }
};

export const callApiDirect = async (app_state, apiName, payload, method = 'POST') => {
    let endpoint = apiListAndData[apiName]?.url;
    const replacements = getReplacementKeys(getCurrentStateData(app_state));
    endpoint = addParametersValues(endpoint, replacements);

    // Initial state (loading starts as true)
    let state = {
        isLoading: true,
        isSuccess: false,
        data: null,
        error: null,
    };

    try {
        const result = await fetchApiData(endpoint, payload, method);
        
        if (result.isSuccess === false) {
            state = {
                isLoading: false,
                isSuccess: true,
                data: null,
                error: result.error,
                msg: result.msg || 'API call failed',
            };
        } else {
            state = {
                isLoading: false,
                isSuccess: true,
                data: result,
                error: null,
            };
        }

        return state;
    } catch (error) {
        state = {
            isLoading: false,
            isSuccess: false,
            data: null,
            error,
        };
        return state;
    }
};


export function useFetchApi(apiName, payload = {}, method = 'POST', autoRun = true, dateKey = null) {
    const { app_state, ui_state } = useSelector((state) => state.app.current_state);
    const [isLoading, setLoading] = useState(autoRun);
    const [isSuccess, setSuccess] = useState(false);
    const [isError, setError] = useState(false);
    const [data, setData] = useState(null);
    const [error, setErrorMessage] = useState(null);
    let endpoint = apiListAndData[apiName]?.url;

    const { property_id, as_of_date, date_from, date_until } = getCurrentStateData(app_state);
    const replacements = getReplacementKeys(getCurrentStateData(app_state));
    endpoint = addParametersValues(endpoint, replacements);
    const callApi = async () => {
        if (!endpoint) {
            console.error(`Invalid API name: ${apiName}`);
            return;
        }

        //  If `dateKey` is a string AND data exists, skip fetch (cache hit)
        if (
            typeof dateKey === 'string' &&
            apiListAndData[apiName]?.data &&
            apiListAndData[apiName].data[dateKey]
        ) {
            setData(apiListAndData[apiName].data[dateKey]);
            setSuccess(true);
            setError(false);
            setLoading(false);
            return;
        }

        setLoading(true);
        setSuccess(false);
        setError(false);
        setErrorMessage(null);

        const result = await fetchApiData(endpoint, payload, method);

        if (result.isSuccess) {
            setData(result.data);
            setSuccess(true);

            if (typeof dateKey === 'string') {
                // Store under keyed cache
                apiListAndData[apiName] = {
                    ...apiListAndData[apiName],
                    data: {
                        ...apiListAndData[apiName]?.data,
                        [dateKey]: result.data
                    },
                    status: 'success',
                    timestamp: Date.now()
                };
            } else {
                // Overwrite for `null` or `true`
                apiListAndData[apiName] = {
                    ...apiListAndData[apiName],
                    data: result.data,
                    status: 'success',
                    timestamp: Date.now()
                };
            }
        } else {
            setError(true);
            setErrorMessage(result.error);

            apiListAndData[apiName] = {
                ...apiListAndData[apiName],
                status: 'error',
                timestamp: Date.now()
            };
        }

        setLoading(false);
    };

    // Initial auto run
    useEffect(() => {
        if (autoRun) {
            callApi();
        }
    }, [endpoint, JSON.stringify(payload)]);

    // Reactive run if `autoRun` is false
    useEffect(() => {
        if (!autoRun) {
            if (typeof dateKey === 'string' && dateKey) {
                // Only call if data is not already cached
                if (!apiListAndData[apiName]?.data?.[dateKey]) {
                    callApi();
                }
            } else if (dateKey === true) {
                callApi();
            }
        }
    }, [dateKey === true ? JSON.stringify(payload) : dateKey]);


    return {
        isLoading,
        isSuccess,
        isError,
        data,
        error,
        // refetch: callApi // optional
    };
}
